// extracted by mini-css-extract-plugin
module.exports = {"container":"SortingSelectView_container__1GL2j","dropdownSortBy":"SortingSelectView_dropdownSortBy__20hZ7","dropdown":"SortingSelectView_dropdown__2gena"};